<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{'Software Version' | translate}}
      </h1>
    </div>

    <section>
      <div class="page-filter clearfix" style="margin: 0">
        <div class="row">
          <div class="col-md-12" style="margin: 0 !important;">
            <h5>{{gatewayVersionInfo.Version}}</h5>
          </div>
        </div>
      </div>
      <div class="content-info evnets">
        <p-table class="deviceTable" [columns]="gatewayVersionData_cols" [value]="gatewayVersionData" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]"
          [scrollable]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header | translate}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              <td style="width:150px" Class="col-nowrap">
                {{'New Version Update' | translate}}
              </td>
              <td style="width:200px">
                {{(rowData.CreateTime) * 1000 | date:'yyyy/MM/dd hh:mm a'}}
              </td>
              <td style="width:200px">
                {{rowData.Status | translate}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="gatewayVersionData_cols.length">
                <div translate class="ui-emptymessage">No Data found</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>

    <section style="margin-top: 2em;">
      <div class="content-info releaseNoteContent">
        <h6>{{ 'Version {version}' | translate : {version: gatewayVersionInfo.Version} }}</h6>
        <div class="scrollContent">
          <p-scrollPanel [style]="{width: '100%', height: '400px'}">
            <div [innerHTML]="gatewayVersionInfo.ReleaseNote"></div>
          </p-scrollPanel>
        </div>
      </div>
    </section>
  </div>
</div>
